import { atom } from 'jotai';

export type BreadcrumbAtom = {
  link: string;
  label: string;
};

export const breadcrumbsAtom = atom<BreadcrumbAtom[]>([]);
